<template>
    <transition name="slide-up-down">
        <slot/>
    </transition>
</template>

<script>
    export default {
        name: "TransitionSlideUpDown",
    };
</script>

<style scoped lang="stylus">
    .slide-up-down-enter-active {
        animation: coming .5s;
        animation-delay: .5s;
        opacity: 0;
    }
    .slide-up-down-leave-active {
        animation: going .5s;
    }

    @keyframes going {
        from {
            transform: translateY(0);
        }
        to {
            transform: translateY(-1rem);
            opacity: 0;
        }
    }
    @keyframes coming {
        from {
            transform: translateY(-1rem);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
</style>